module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main column no-header",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "background-login"
  }), _vm._v(" "), _c('div', {
    staticClass: "login subscribe active maintenance"
  }, [_c('div', {
    staticClass: "w-100 text-center"
  }, [_c('logo')], 1), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('h1', [_vm._v("Page Introuvable")]), _vm._v(" "), _c('p', [_vm._v("La page que vous demandé est actuellement introuvable")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49d77ac1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/NotFound.vue
// module id = 1122
// module chunks = 0